import { ReportLayout } from '@app/components/reports/components/report-layout';
import { useParams } from 'react-router-dom';
import { useCCFReportResult } from './ccf-report-result-context';
import { useCompanyReportSections } from './company-report-sections';
import { useCCFFormattedReportSections } from './company-report-utils';
import CCFReportLayoutHeader from './components/ccf-report-layout-header';
import CCFReportIntro from './pages/ccf-report-intro';

export default function CCFReport() {
  const { result, resultStatus, resultError, downloadMode } =
    useCCFReportResult();
  const { report_uuid } = useParams();

  const reportSections = useCompanyReportSections(report_uuid!);
  const formattedData = useCCFFormattedReportSections(reportSections, result);

  return (
    <ReportLayout
      reportType="ccf"
      reportUuid={report_uuid!}
      title={result?.title}
      organizationName={result?.organization.name}
      resultStatus={resultStatus}
      resultError={resultError}
      introComponent={<CCFReportIntro />}
      headerComponent={<CCFReportLayoutHeader />}
      data={formattedData}
      sections={reportSections}
      defaultActive={'Introduction'}
      downloadMode={downloadMode}
    />
  );
}
